import { Carousel, WingBlank } from 'antd-mobile';
import ReactDOM from 'react-dom';
class MainSlider extends React.Component {
    state = {
        data: ['1', '2', '3'],
        imgHeight: window.lib.flexible.rem2px(3.906667),
    }
    componentDidMount() {
        // simulate img loading
        this.setState({
            //'imgHeight':(ReactDOM.findDOMNode(this).clientWidth-2*window.lib.flexible.rem2px(0.2))*0.43088
            'imgHeight':(ReactDOM.findDOMNode(this).clientWidth*0.906667)*0.43088
        })
    }
    componentWillReceiveProps(nextProps) {
        if(this.props.orientation!=nextProps.orientation){
            this.setState({
                //'imgHeight':(ReactDOM.findDOMNode(this).clientWidth-2*window.lib.flexible.rem2px(0.2))*0.43088
                'imgHeight':(ReactDOM.findDOMNode(this).clientWidth*0.906667)*0.43088
            })
        }

    }
    render() {
        let {data,orientation}=this.props;
        var count=0;
        let aarr=[],index=0;
        for(let i=0;i<data.length;i++){
            let {ptt,pid,purl,pimg}=data[i];
            aarr.push(
                <a
                    className={'main-slider-a'}
                    data-ptt={ptt}
                    key={pid}
                    href={purl}
                    style={{
                        position: 'relative',
                        //top: this.state.slideIndex === index ? -10 : 0,
                        height: this.state.imgHeight,
                        //boxShadow: '2px 1px 1px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    <img
                        src={pimg}
                        alt=""
                        style={{ width: '100%', verticalAlign: 'top','height':'100%' }}
                        onLoad={() => {
                            // fire window resize event to change height
                            window.dispatchEvent(new Event('resize'));
                            //this.setState({ imgHeight: 'auto' });
                        }}
                    />
                </a>
            )
        }
        return (
            //<WingBlank size="sm">
                <Carousel
                    cellSpacing={window.lib.flexible.rem2px(0.2)}
                    slideWidth={0.906667}

                          infinite
                          beforeChange={(from, to) => {}}
                          afterChange={index => this.setState({ slideIndex: index })}
                >
                    {aarr}
                </Carousel>
            //</WingBlank>
        );
    }
}
export default  MainSlider;